import React from "react";
import { Component } from "react";
import Icons from "../../icon";
import { TYPE_FUNCTION } from "../../../constants/external-constants";
export class CustomDropdown extends Component {
    constructor(props){
        super(props);
        this.state={
            isActive:false
        }
    }

    handleToggle=()=>{
        
        if (typeof this.props.toggleActiveState === TYPE_FUNCTION) {          
            this.props.toggleActiveState();
        }else {
            this.setState({
                isActive: !this.state.isActive
            })
        }       
    }
    
    render() {
        return(
            <>
                <div className="local-contact-container" onClick={this.handleToggle}>
                    <Icons
                        customClassName="icon-circle-plus"
                        name={(this.state.isActive || this.props.activeDropdown) ? `circle-minus-reg` : `circle-plus-reg`}
                        size="20px"
                        containerClass="icon-circle-plus-container"
                    />
                    <h1 className="local-contact-header">{this.props.label}</h1>
                </div>
                {
                    (this.state.isActive || this.props.activeDropdown )&& this.props.children
                }               
            </>
        )
    }
}